import { Vowel1, Vowel2, Vowel3, Vowel4, Vowel5, Vowel6, Vowel7, Vowel8, Vowel9, Vowel10, Vowel11, Vowel12, Vowel13, Vowel14 } from 'assets'

const vowelSound = {
    "ַ": {
        image: Vowel1,
        name: "פתח"
    },
    "ִ": {
        image: Vowel2,
        name: "חיריק"
    },
    "ָ": {
        image: Vowel3,
        name: "קמץ"
    },
    "ִ": {
        image: Vowel4,
        name: "חיריק"
    },
    "ֵ": {
        image: Vowel5,
        name: "צירה"
    },
    "ֶ": {
        image: Vowel6,
        name: "סגול"
    },
    "ֹ": {
        image: Vowel14,
        name: "חולם חסר"
    },
    "ִי": {
        image: Vowel7,
        name: "חיריק מלא"
    },
    "וֺֹ": {
        image: Vowel8,
        name: "חולם מלא"
    },
    "וֺ": {
        image: Vowel8,
        name: "חולם מלא"
    },
    "וּ": {
        image: Vowel9,
        name: "שורוק"
    },
    "ֻ": {
        image: Vowel13,
        name: "קובוץ",
    },
    "ֱ": {
        image: Vowel10,
        name: "חטף סגול"
    },
    "ֳ": {
        image: Vowel11,
        name: "חטף קמץ"
    },
    "ֲ": {
        image: Vowel12,
        name: "חטף פתח"
    }
}

export default vowelSound

